import { Badge, Table } from '@radix-ui/themes';
import {
  ITargetProps,
  renderNumber,
} from 'components/common/training-data-table/common';

export const DeltaCell = (props: ITargetProps) => {
  const roundedDelta =
    props.value === undefined
      ? NaN
      : Math.round(10 * (props.value - props.target)) / 10;

  return (
    <Table.Cell align="right">
      {!isNaN(roundedDelta) && (
        <Badge mr="2">
          {roundedDelta > 0 ? '+' : '-'}
          {roundedDelta !== 0 &&
            Math.abs(roundedDelta).toFixed(props.precision)}
        </Badge>
      )}
      {renderNumber(props.value, props.precision)}
    </Table.Cell>
  );
};
